import { SharedService } from 'src/app/services/shared.service';
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LoginService } from './login.service';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { UserMaster } from '../models/Masters/userMaster';

@Injectable({
  providedIn: 'root'
})

export class AuthGuardService implements CanActivate {
  url: string;
  user: UserMaster;

  constructor(private router: Router, private loginService: LoginService, private sharedService: SharedService
    , private httpClient: HttpClient) {
    this.url = sharedService.baseURL;
  }
  
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    this.user = this.loginService.user();

    if (this.loginService.isLogged()) {
      const url = state.url.split('/')[2] ? state.url.split('/')[2] :
        state.url.split('/')[1] ? state.url.split('/')[1] : state.url.split('/')[0];
      
      if (this.user != null && this.user.isFirstLogin == false && url !== 'changepassword') {
        this.router.navigateByUrl('/dashboard/changepassword');
      }

      if (url === 'dashboard' || url === 'dashboard1' || url === 'changepassword') {
        return of(true);
      } else {
        return this.httpClient.post(`${this.url}/api/RoleMaster/CheckRouteUrl`, { url, roleId: this.user.roleId }).pipe(
          map((res: any) => {
            if (res.responseCode === '-1') {
              this.router.navigateByUrl('/404');
              return false;
            } else {
              return true;
            }
          }),
          catchError((err) => {
            return of(false);
          })
        );
      }
    }

    localStorage.clear();
    this.router.navigateByUrl('/login');
    return of(false);
  }
}
